import { get } from "@/utils/request";

export const MERCHANT_ID = Number(process.env.VUE_APP_MERCHANT_ID || 2);

export const getProducts = (data = {}) =>
  get("/product/merchant/pc/pro/list", {
    merId: MERCHANT_ID,
    cid: data.cid || (data.category_uids && data.category_uids[0]) || undefined,
    keyword: data.keyword || undefined,
    page: data.page || 1,
    limit: data.limit || data.page_size || 12,
    priceOrder: data.priceOrder,
    salesOrder: data.salesOrder,
    minPrice: data.minPrice,
    maxPrice: data.maxPrice
  });

export const getFilterList = () => Promise.resolve({ code: 200, data: [] });
export const getCategoryList = () => get(`/product/merchant/${MERCHANT_ID}/category/list`);
export const getProductDetail = (data) => get(`/product/detail/${data.id || data.uid}`);
export const getSkuDetail = (id) => get(`/product/sku/detail/${id}`);
export const getSolutions = (data) => get("/product/list", data);
